import { cn } from "@/utils/cn";

// ─── Headings
export const H1 = ({ className, ...props }: React.ComponentProps<"h1">) => (
  <h1
    className={cn(
      "font-heading text-4xl font-bold tracking-tight text-foreground",
      className,
    )}
    {...props}
  />
);

export const H2 = ({ className, ...props }: React.ComponentProps<"h2">) => (
  <h2
    className={cn(
      "font-heading text-3xl font-semibold tracking-tight text-foreground",
      className,
    )}
    {...props}
  />
);

export const H3 = ({ className, ...props }: React.ComponentProps<"h3">) => (
  <h3
    className={cn(
      "font-heading text-2xl font-semibold tracking-tight text-foreground",
      className,
    )}
    {...props}
  />
);

export const H4 = ({ className, ...props }: React.ComponentProps<"h4">) => (
  <h4
    className={cn(
      "font-heading text-xl font-semibold tracking-tight text-foreground",
      className,
    )}
    {...props}
  />
);

export const H5 = ({ className, ...props }: React.ComponentProps<"h5">) => (
  <h5
    className={cn(
      "font-heading text-lg font-medium text-foreground",
      className,
    )}
    {...props}
  />
);

export const H6 = ({ className, ...props }: React.ComponentProps<"h6">) => (
  <h6
    className={cn(
      "font-heading text-base font-medium text-foreground",
      className,
    )}
    {...props}
  />
);

// ─── Body Text
export const P = ({ className, ...props }: React.ComponentProps<"p">) => (
  <p
    className={cn("text-base leading-7 text-foreground", className)}
    {...props}
  />
);

export const Lead = ({ className, ...props }: React.ComponentProps<"p">) => (
  <p
    className={cn("text-xl leading-7 text-muted-foreground", className)}
    {...props}
  />
);

export const Large = ({
  className,
  ...props
}: React.ComponentProps<"span">) => (
  <span
    className={cn("text-lg font-medium text-foreground", className)}
    {...props}
  />
);

export const Small = ({
  className,
  ...props
}: React.ComponentProps<"small">) => (
  <small
    className={cn("text-sm leading-none text-foreground", className)}
    {...props}
  />
);

export const Subtle = ({
  className,
  ...props
}: React.ComponentProps<"span">) => (
  <span className={cn("text-sm text-muted-foreground", className)} {...props} />
);

// ─── Inline
export const InlineCode = ({
  className,
  ...props
}: React.ComponentProps<"code">) => (
  <code
    className={cn(
      "relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold text-foreground",
      className,
    )}
    {...props}
  />
);

export const Strong = ({
  className,
  ...props
}: React.ComponentProps<"strong">) => (
  <strong
    className={cn("font-semibold text-foreground", className)}
    {...props}
  />
);

export const Em = ({ className, ...props }: React.ComponentProps<"em">) => (
  <em className={cn("italic text-foreground", className)} {...props} />
);

// ─── Block
export const Blockquote = ({
  className,
  ...props
}: React.ComponentProps<"blockquote">) => (
  <blockquote
    className={cn(
      "border-s-2 border-border ps-4 italic text-muted-foreground",
      className,
    )}
    {...props}
  />
);

export const Label = ({
  className,
  ...props
}: React.ComponentProps<"span">) => (
  <span
    className={cn(
      "text-sm font-medium leading-none text-foreground",
      className,
    )}
    {...props}
  />
);
